
        <p>{{version?.name}}</p>
        <div (click)="onRemove()" class="remove_version_control"></div>
